import React from 'react'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'

import ArBlogPost from 'src/components/blog/ArBlogPost/ArBlogPost'
import ArPressRelease from 'src/components/blog/ArPressRelease/ArPressRelease'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${ media.tablet`
    margin-left: ${ p => !p.scIsPressRelease && '-40px' };
    flex-direction: row;
  ` }

  ${ media.desktop`
    margin-left: ${ p => !p.scIsPressRelease && '-75px' };
  ` }
`

const StyledArticle = styled(ArBlogPost)`
  ${ media.tablet`
    padding-left: 40px;
    width: 50%;
  ` }

  ${ media.desktop`
    padding-left: 75px;
    width: 33.33%;
  ` }
`

class ArBlogItemsList extends React.Component {
  render () {
    return (
      <StyledContainer scIsPressRelease={this.props.itemsType !== 'article'}>
        {this.props.items.map((item, index) => this.props.itemsType === 'article' ? <StyledArticle key={index} data={item} itemIndex={index} /> : <ArPressRelease key={index} data={item} itemIndex={index} />)}
      </StyledContainer>
    )
  }
}

export default ArBlogItemsList
